/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { MdAdd, MdOutlineDelete } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";

import Datepicker from "react-tailwindcss-datepicker";

import { ApisContext } from "../contexts/ApiConterxt";
import { AuthContext } from "../contexts/Auth.Context";
import { toast } from "react-toastify";

import axios from "axios";
import { useNavigate } from "react-router-dom";

const EditSale = () => {
  const BASE_URL = window.config.API_URL;
  const navigate = useNavigate();
  const [flashSales, setFlashSales] = useState(null);
  const [flashSalesPending, setFlashSalesPending] = useState(false);
  const { setEditSaleProductsBar, currentColor } = useStateContext();
  const [dateValue, setDateValue] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: (() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split("T")[0];
    })(),
  });
  let { saleId } = useParams();

  const {
    state: ContextState,
    getProducts,
    setPendingFun,
    getCategories,
    setSelectedProductsIdsSaleFun,
  } = useContext(ApisContext);
  const { selectedProductsIdsSale, categories } = ContextState;
  const { state: AuthContextState, setUnAuthorizedFun } =
    useContext(AuthContext);
  const { user } = AuthContextState;

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      setPendingFun(true);
      await getProducts(user);
      await getCategories(user);
      await getFlashSale(user);
      setPendingFun(false);
    };
  
    fetchData();
  }, []);


  useEffect(() => {
    if (flashSales) {
      // console.log(categories, "flash categories"); 
      setValue("name", flashSales?.campaign_name);
      setSelectedProductsIdsSaleFun(
        flashSales?.flash_sale_products?.map((product) => product.product)
      );
      
      
      

      let dateValue = {
        startDate: flashSales?.start_date,
        endDate: flashSales?.end_date,
      };
      setDateValue(dateValue);
      flashSales?.flash_sale_products?.map((product) =>
        setValue(`${product.product.id}`, product.discount)
      );
    }
  }, [flashSales]);

  const handleDateChange = (newValue) => {
    setDateValue(newValue);
  };
 

  // console.log(selectedProductsIdsSale, "selectedProductsIdsSale");

  const handleDelete = (itemId) => {
    const currentIds = selectedProductsIdsSale; // Assuming `selectedProductsIdsSale` is the current state value
    const updatedIds = currentIds.filter((id) => id !== itemId);
    setSelectedProductsIdsSaleFun(updatedIds);
  };

  const submitEditSaleHandler = async (data) => {
    setPendingFun(true);
    let name = data.name;
    let end_date = dateValue.endDate;
    let start_date = dateValue.startDate;
    delete data.name;
    delete data.end_date;
    delete data.start_date;
    // console.log(data, "submiteEditSaleHandler");
    let keys = Object.keys(data);
    let values = Object.values(data);
    if (keys.length <= 0 || values.length <= 0) {
      toast.error("Please select a valid product and discout");
      return;
    }
    keys = [];
    values = [];

    selectedProductsIdsSale?.map((item, i) => {
      keys.push(item?.id);
      if (data.hasOwnProperty(item?.id)) {
        values.push(data[item?.id]);
      }
    });
    const formdata = new FormData();
    formdata.append("campaign_name", name);
    formdata.append("start_date", start_date);
    formdata.append("end_date", end_date);
    formdata.append("product_ids", keys.toString());
    formdata.append("discounts", values.toString());

    // console.log(formdata.get("product_ids"));

    // console.log(formdata.get("discounts"));

    // Convert FormData to x-www-form-urlencoded format
    const urlSearchParams = new URLSearchParams(formdata);
    const formDataEncoded = urlSearchParams.toString();

    try {
      const tokenStr = user.token;

      const response = await axios.patch(
        BASE_URL + `flashSale/${saleId}`,
        formDataEncoded,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      // setPending(false);

      if (response.status === 200) {
        if (response.data.Success === true && response.data.data) {
          setPendingFun(false);

          toast.success("Sale successfully Updated!");
          setSelectedProductsIdsSaleFun(null);
          navigate("/flashSale");
          return response.data;
        } else if (response.data.status === "error") {
          setPendingFun(false);

          toast.error(response.data.message);
          setSelectedProductsIdsSaleFun(null);
        } else {
          setPendingFun(false);
          toast.error(response.data.message + "-" + response.data.data);
          setSelectedProductsIdsSaleFun(null);
        }
      } else if (response.status === 404 || response === null) {
        setPendingFun(false);

        toast.error("Request Error: Sale not Updated");
        setSelectedProductsIdsSaleFun(null);
      } else if (response.status === 401) {
        setPendingFun(false);

        // toast.error("Unauthorized: Please log in again");
        setSelectedProductsIdsSaleFun(null);
      } else {
        setPendingFun(false);

        toast.error(`Error ${response.status}: ${response.statusText}`);
        setSelectedProductsIdsSaleFun(null);
      }
    } catch (error) {
      setPendingFun(false);
      if (error.response.status === 401) {
        // toast.error("Error- " + error.response.data.message);
        setUnAuthorizedFun(true);
        setSelectedProductsIdsSaleFun(null);
      } else {
        // console.log("Error- ", error.response);
        toast.error("Error- " + error.response.data.message);
        setSelectedProductsIdsSaleFun(null);
      }
    }
  };
  const getFlashSale = async (user) => {
    //   console.log(user, "getCategories");
    setPendingFun(true);

    let tokenStr = user.token;
    try {
      await axios
        .get(BASE_URL + `flashSale/${saleId}`, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        })
        .then((response) => {
          //   console.log(response, "Category");
          setPendingFun(false);
          if (response.status === 200) {
            if (response.data.Success === true) {
              // console.log("sales", response.data.data);
              setFlashSales(response.data.data);
              //   localStorage.removeItem("user");
              // toast.success("Data successfully Received");
              // navigate("/");
            } else {
              toast.error("Error data not found");
            }
          } else {
            toast.error("data not found" + response);
          }
        });
    } catch (error) {
      setPendingFun(false);
      if (error.response.status === 401) {
        // toast.error("Error- " + error.response.data.message);
        setUnAuthorizedFun(true);
      } else {
        // console.log("Error- ", error.response);
        toast.error("Error- " + error.response.data.message);
        setFlashSales(null);
      }
    }
  };

  const [salePrices, setSalePrices] = useState({});
  
  const handleChangeSalePrice = (salePrice, id, price) => {
    if (salePrice) {
      clearErrors(`${id}`);
      setValue(`${id}`, ((price - salePrice) / price) * 100);
    } else {
      setError(`${id}`, { type: 'required', message: 'Sale price required' });
      setValue(`${id}`, "");
    }
    const updatedSalePrices = salePrices; 
    updatedSalePrices[id] = salePrice;
    setSalePrices(updatedSalePrices);
  }


  const calculateSalePrice = (originalPrice, discountPercentage) => {
    const originalPriceFloat = parseFloat(originalPrice);
    const discountPercentageFloat = parseFloat(discountPercentage);

    // console.log(originalPriceFloat, discountPercentage, discountPercentageFloat )

    if (!isNaN(originalPriceFloat) && !isNaN(discountPercentageFloat)) {
      const discountAmount = (originalPriceFloat * discountPercentageFloat) / 100;
      const salePriceValue = originalPriceFloat - discountAmount;
      return salePriceValue.toFixed(2); // Round to 2 decimal places
    } else {
      return '';
    }
  };

  useEffect(() => {
    // Calculate sale prices and store them in state
    const updatedSalePrices = {};
    selectedProductsIdsSale?.forEach((item) => {
      const salePrice = calculateSalePrice(item?.price, item?.in_flash_sale_details?.discount);
      updatedSalePrices[item.id] = salePrice;
    });
    setSalePrices(updatedSalePrices);
  }, [selectedProductsIdsSale]);

  return (
    <div className="mt-24 sm:mt-8 md:mt-5 px-5 sm:px-8 md:px-14">
      <div className="text-2xl text-gray-700 dark:text-gray-50 font-semibold mb-5">
        Edit Sale
      </div>
      <form
        onSubmit={handleSubmit((data) => submitEditSaleHandler(data))}
        noValidate
      >
        <div className="grid gap-6 md:grid-cols-2">
          <div>
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Campaign Name
                <span className="text-red-600 text-xs">*</span>
              </label>
              <input autoComplete="off"
                type="text"
                id="name"
                className={`border text-sm rounded-lg block w-full p-2.5 ${
                  errors.name
                    ? "bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 focus-visible:outline-red-600"
                    : "bg-gray-50 border-gray-300 text-gray-900 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                } `}
                placeholder="Enter Campaign name"
                {...register("name", {
                  required: {
                    value: true,
                    message: "Campaign name required",
                  },
                })}
              />
              <small className="text-sm text-red-600 dark:text-red-500">
                {errors.name?.message}
              </small>
            </div>
          </div>
          <div className="w-full mb-4">
            <small className=" text-gray-900 dark:text-gray-200 text-sm">
              Select From to End Date
              <span className="text-red-600 text-xs">*</span>
            </small>
            <div className="mt-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white ">
              <Datepicker value={dateValue} onChange={handleDateChange} />
            </div>
          </div>
        </div>
        <div className="border dark:border-gray-500 text-sm rounded-lg block w-full p-2.5 mb-5">
          <div className="flex justify-between items-center  mb-3">
            <div className="ps-3 text-gray-800 dark:text-gray-300 font-semibold text-xl ">
              Products
            </div>
            <button
              type="button"
              onClick={() => setEditSaleProductsBar(true)}
              style={{
                background: currentColor,
              }}
              className="w-fit justify-center focus:outline-none text-white hover:opacity-80 font-medium rounded-lg text-base px-3 py-2 flex items-center gap-1"
            >
              <div className="text-xl">
                <MdAdd />
              </div>
              Remove & Add Product
            </button>
          </div>
          <div className="align-middle inline-block w-full shadow-lg overflow-x-auto rounded-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-sm text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                  <th scope="col" className="ps-6 px-3 py-3">
                    Sale Price
                  </th>
                  <th scope="col" className="px-3 py-3">
                    Discount
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3">
                    Product Image
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3">
                    Product name
                  </th>
                  <th scope="col" className="px-3 py-3">
                    Category
                  </th>

                  <th scope="col" className="px-3 py-3">
                    Price
                  </th>
                  <th scope="col" className="px-3 py-3 whitespace-nowrap">
                    SALE PRICE
                  </th>
                  <th scope="col" className="px-3 py-3 pe-5">
                    STOCK
                  </th>

                </tr>
              </thead>
              <tbody>
                {selectedProductsIdsSale?.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <td className="ps-6 px-3 py-3 dark:text-white">
                        <input autoComplete="off"
                          type="text"
                          id={`${item.id}`}
                          value={salePrices[item.id]}
                          onChange={(e)=>handleChangeSalePrice(e.target.value, item.id, item?.price)}
                          className={`border text-sm rounded-lg block w-fit p-2.5 ${
                            errors[`${item.id}`]
                              ? "bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 focus-visible:outline-red-600"
                              : "bg-gray-50 border-gray-300 text-gray-900 dark:bg-gray-700 dark:border-gray-300 dark:placeholder-gray-200 dark:text-white"
                          } `}
                          placeholder="Enter Sale Price"
                          // onChange={(e) => handleInputChange(e, item.id)}
                        />
                        <small className="text-sm text-red-600 dark:text-red-500">
                          {errors[`${item.id}`]?.message}
                        </small>
                      </td>
                      <td className="px-3 py-3 dark:text-white">
                        <input autoComplete="off"
                          type="text"
                          id={`${item.id}`}
                          className={`border text-sm rounded-lg block w-full p-2.5 ${
                            errors[`${item.id}`]
                              ? "bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 focus-visible:outline-red-600"
                              : "bg-gray-50 border-gray-300 text-gray-900 dark:bg-gray-700 dark:border-gray-300 dark:placeholder-gray-200 dark:text-white"
                          } `}
                          placeholder="Enter Discount"
                          {...register(`${item.id}`, {
                            required: {
                              value: true,
                              message: "Discount required",
                            },
                          })}
                          // onChange={(e) => handleInputChange(e, item.id)}
                        />
                        <small className="text-sm text-red-600 dark:text-red-500">
                          {errors[`${item.id}`]?.message}
                        </small>
                      </td>
                      <th
                        scope="row"
                        className="ps-6 px-3 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white flex justify-center"
                      >
                        <div className="rounded-lg h-12 w-12 border ">
                          <img
                            src={item?.product_image?.[0]?.image}
                            className="rounded-lg h-12 w-12 border object-cover"
                            alt="..."
                          />
                        </div>
                      </th>
                      <td className="ps-6 px-3 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        <div className="whitespace-normal">
                          {item?.title?.substr(0, 23)}
                          {item?.title?.length > 20 ? "..." : ""}
                        </div>
                      </td>
                      <td className="px-3 py-4">
                        {item?.category?.category_name}
                      </td>
                      <td className="px-3 py-4 font-semibold">
                        {item?.price}
                      </td>
                      <td className="px-3 py-4 font-semibold">
                        {Math.round(item?.price -
                          (item?.price * item?.discount_percent) / 100)}
                      </td>
                      <td className="px-3 py-4">{item?.stock}</td>

                      {/*<td className="px-3 py-4">
                        <div className="text-2xl">
                          <button
                            onClick={() => handleDelete(item)}
                            className="flex justify-center font-medium text-red-600 dark:text-red-500 hover:underline"
                          >
                            <MdOutlineDelete />
                          </button>
                        </div>
                        </td>*/}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="text-right">
          <button
            type="submit"
            style={{
              background: currentColor,
            }}
            className=" text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center hover:opacity-80"
          >
            Update Sale
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditSale;
